var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',[_c('v-tabs-bar',_vm._l((_vm.navItems),function(i){return _c('v-tabs-item',{key:i.text,attrs:{"href":'#tab-' + i.text}},[_vm._v("\n         "+_vm._s(i.text)+"\n       ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }